import { ChevronsUpDownIcon, LogOutIcon, UserRoundIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSnapshot } from 'valtio';

import { getInitials } from '../../../../utils/misc.js';

import { authState } from '../../../../services/state/auth-state.jsx';
import { Avatar, AvatarFallback } from '../../../ui/avatar.jsx';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../../../ui/dropdown-menu.jsx';
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '../../../ui/sidebar.jsx';

export function NavUser() {
  const { isMobile } = useSidebar();
  const { user: loggedUser, logout } = useSnapshot(authState);

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="h-auto data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <Avatar className="size-8 rounded-xl border border-input">
                <AvatarFallback className="rounded-xl bg-white dark:bg-muted/40">
                  {getInitials(loggedUser.fullName)}
                </AvatarFallback>
              </Avatar>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-semibold">
                  {loggedUser.fullName}
                </span>
                <span className="truncate text-xs">
                  {loggedUser.details.role}
                </span>
                <span className="truncate text-xs">{loggedUser.email}</span>
              </div>
              <ChevronsUpDownIcon className="ml-auto size-4" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
            side={isMobile ? 'bottom' : 'right'}
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabel className="p-0 font-normal">
              <div className="flex items-center gap-2.5 px-1 py-1.5 text-left text-sm">
                <Avatar className="size-8 rounded-xl border border-input">
                  <AvatarFallback className="rounded-xl dark:bg-muted/40">
                    {getInitials(loggedUser.fullName)}
                  </AvatarFallback>
                </Avatar>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-semibold">
                    {loggedUser.fullName}
                  </span>
                  <span className="truncate text-xs">
                    {loggedUser.details.role}
                  </span>
                  <span className="truncate text-xs">{loggedUser.email}</span>
                </div>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuItem asChild>
                <Link to="/backoffice/account">
                  <UserRoundIcon className="mr-2 size-3.5" />
                  Conta
                </Link>
              </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => logout()}>
              <LogOutIcon className="mr-2 size-3.5" />
              Sair
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
